import { render, staticRenderFns } from "./AnularTraslados.vue?vue&type=template&id=3c770530"
import script from "./AnularTraslados.vue?vue&type=script&lang=js"
export * from "./AnularTraslados.vue?vue&type=script&lang=js"
import style0 from "./AnularTraslados.vue?vue&type=style&index=0&id=3c770530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports